<!-- Screenname:Store Master Table View
Developer Name:Tharuni.
Created date on:1/02/2023
Last Working date on:
Comments and Suggestions:
TS File:StoreService -->
<template>
  <!-- <Header></Header> -->
  <div class="overall-bg">
    <b-container>
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('stores.StoreMaster.Master')" :contenttext="$t('stores.StoreMaster.content')">
          </Headerlayout>
        </b-col>
      </b-row>
      <!-- {{ showModal }} -->
      <!-- <Filter /> -->
      <!-- <n-input placeholder="Search" v-model="filter" /> -->
      <!-- <DataTable :datalist="items" :dataheader="headers"
                                                                                                                                                                                                                                                                  @detailsclick="$router.push({ path: '/StoreMasterDetails' })" @createclick="handleClick()" /> -->
      <!--<UnitModal :showmodal=showpopModal /> -->
      <!-- <Empty route="/Createstore"
                                                                                                                                                                                                                                                          econtent="Your Store Master List empty right now Click below to create a new one"
                                                                                                                                                                                                                                                                  eheader="Store master Details" img="/src/assets//assets/Img/Masters SVG/Brand master-01.svg" /> -->

      <b-row class="">
        <b-col sm="12">
          <Loader :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty :createline="false" v-if="List.length === 0" eheader="Item Store Mapping"
              econtent="Item Store Mapping" eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />
            <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines" :rows="10"
              :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll" :columns="headers"
              dataKey="Id" :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
              @row-click="RowClick">
              <template v-slot:Add>
                <!-- <span class="add">
                <AddButton
                  @click="IsAdd()"
                  :btnname=" $t('btn.plusaddnew')"
                  class="float-rights my-3"
                ></AddButton>
              </span> -->
              </template>
              <template v-slot:action="{ data }">
                <span>
                  <EditIcon @click="IsConfirmEdit(data)" class="me-3" />

                  <DeleteIcon @click="IsConfirmDel(data)" />
                </span>
              </template>
            </Tableview>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
      :content="$t('confirmation.editcontent')" />
    <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
    <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
    <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />
  </div>
</template>

<script lang="ts">
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { defineComponent, ref, h, computed, onMounted, watch } from "vue";


import commonservice from "../../../../../modules/Inventory/Service/StoreService";

// import Tableview from '../../../../../../components/FormComponents/Table.vue';
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Mapping from "../../../../../components/FormComponents/Mapping.vue";
import ItemStoreMappingService from "../../../../../modules/Inventory/Service/ItemStoreMappingService";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";

export default defineComponent({
  components: {
    // Header,


    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    Mapping,
    MasterEmpty,
    Loader,
  },
  setup() {
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const router = useRouter();
    const routers = useRoute();
    let loading = ref(false);
    const filter = "";
    const showmodalref = ref(false);
    const storeId = ref(0);
    const storeType = ref(0);

    const IsAdd = () => {
      router.push({
        path: "/Createstore",
      });
    };
    let loading1 = ref(false);
    const showDialog = ref(false);
    const selectedItem = ref();
    const rowFocus = ref(false);
    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const dataEdit = ref({});
    const MappingPop = ref({
      visible: false,
      content: "",
    });

    const ParamValues = ref({
      itemid: 0,
    });

    let itemid = routers.query.id;
    ParamValues.value.itemid = Number(itemid);
    watch(
      () => routers.query.id,
      (newVal: any) => {
        debugger;

        ParamValues.value.itemid = Number(newVal);
        IsShow();
      }
    );
    // const edit = (data) => {
    //     selectedItem.value = data
    //     showDialog.value = true
    // }
    // const AddNew = () => {
    //     showDialog.value = true
    //     selectedItem.value = null
    // }
    // const handleClick = () => {
    //     selectedItem.value = null;
    //     showDialog.value = false;
    // }
    // const onHide = () => {
    //     debugger;
    //     selectedItem.value = null;
    //     showDialog.value = false;

    // }
    function RowClick(event: any) {
      debugger;
      // Editmodel.value = true
      rowFocus.value = true;
      dataEdit.value = event.data;
      // alert(event.data.Id)
      // router.push({
      //     path: '/StoreMasterDetails',
      //     query: {
      //         storeId: event.data.Id,
      //         storeType: event.data.StoreTypeId
      //     }
      // })
      router.push({
        path: "/StoreMasterDetails",
        query: {
          Id: event.data.Id,
          Type: "StoreId",
          storeType: event.data.StoreTypeId,
        },
      });
    }
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
      let SessionUserData = localStorage.getItem("UsersData");
      let usersData;
      if (SessionUserData !== null) {
        usersData = JSON.parse(SessionUserData);
      }
      IsShow();
    });

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Escape" && MappingPop.value.visible == true) {
        MappingPop.value.visible = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }
    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = false;
      Deletemodel.value = true;
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      MappingPop.value.visible = false;
    }
    let List = ref([]);
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: List },
      BranchId: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      StoreTypeName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };
    const headers = [
      {
        header: "Store Code",
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Store Name",
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Branch",
        field: "BranchName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Type",
        field: "StoreTypeName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      // {
      //     header: 'Transaction Billing',
      //     field: '',
      //     filterTemplate: 'MultiSelect',
      //     ShowMactchMode: false
      // },
      {
        header: "Avl Qty",
        field: "StockInHand",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Value",
        field: "StockValue",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      // {
      //   header: "About to Expire",
      //   field: "",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   bodyclass: "bluecolor",
      // },
      // {
      //   field: "action", header: "Action", slot: "action",
      //   frozencolumn: true, sortable: false
      // },
    ];
    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));

    //Load Store Table
    async function IsShow() {
      debugger;
      loading.value = true;
      const result1 = await ItemStoreMappingService.ItemList();
      debugger

      let datas = result1["result"].filter(
        (item) => item.ItemId == ParamValues.value.itemid
      );
      let arr: any = [];
      if (datas.length > 0) {
        for (let i = 0; i < datas.length; i++) {
          arr[i] = datas[i].StoreId;
        }
      }
      debugger
      // const result = await commonservice.getStoreList();
      let result = await commonservice.getStoreListByUserId(
        usersData.UserId,
        usersData.OrganizationId,
        usersData.Admin,
        usersData.BranchId
      );
      console.log(result);
      // List.value = result["result"].filter((value)=>arr.includes(value.Id));
      let arr1 = result["result"].filter((value) => arr.includes(value.Id));
      let arr2 = arr1.map((item) => {
        const item2 = datas.find((item2) => item2.StoreId == item.Id);
        return {
          ...item,
          StockInHand: item2["StockInHand"],
          StockValue: item2.StockValue,
        };
      });
      List.value = arr2;
      loading.value = false;
      console.log(List.value);
    }
    //Store Edit
    function IsEdit(data) {
      debugger;
      router.push({
        name: "Createstore",
        query: {
          storeId: data.Id,
          storeType: data.StoreTypeId,
        },
      });
    }
    async function IsDelete(data) {
      const result = await commonservice.deleteStore(data.Id);
      console.log(result);
      let message = result["ErrorInfo"].ErrorCode;
      if (result["result"] != "False" && message == null) {
        Deletemodel.value = false;
        MappingPop.value.content = result["result"];
        MappingPop.value.visible = true;
      } else if (message == null) {
        deletepop.value = true;
        Deletemodel.value = false;
        rowFocus.value = false;
        IsShow();
      }
    }

    return {
      filter,
      showmodalref,
      IsAdd,
      showpopModal: showmodalref,
      List,
      headers,
      loading1,
      filters,
      globalFilterFields,
      IsShow,
      IsEdit,
      IsDelete,
      RowClick,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      dataEdit,
      Editmodel,
      editItems,
      MappingPop,
      ParamValues,
      loading,
      // show: showmodal.value
    };
  },
});
</script>
